export default {
  inject: ['load'],
  data() {
    return {
      allPhoneOnlineLocations: null,
      phoneOnlineLocation: null,
    };
  },
  methods: {
    getPhoneOnlineLocationFunction: function (id) {
      this.$store.dispatch('getPhoneOnlineLocation', id).then(() => {
        if (this.$store.state.phoneOnlineLocationModule.successFlag) {
          this.phoneOnlineLocation =
            this.$store.state.phoneOnlineLocationModule.phoneOnlineLocation;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneOnlineLocationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getPhoneOnlineLocationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.phoneOnlineLocationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getPhoneOnlineLocationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllPhoneOnlineLocationFunction: function () {
      this.$store.dispatch('getAllPhoneOnlineLocation').then(() => {
        if (this.$store.state.phoneOnlineLocationModule.successFlag) {
          this.allPhoneOnlineLocations =
            this.$store.state.phoneOnlineLocationModule.allPhoneOnlineLocations;
          if (this.$route.name == 'dispatchMap' || this.$route.name == 'newMissionWithMap800' || this.$route.name == 'followUpMap' || this.$route.name == 'eocMap') {
            this.readyCodeData();
            return;
          }
          if (this.$route.name == 'admissionMap') {
            this.readyCodeData();
            return;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.phoneOnlineLocationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllPhoneOnlineLocationFunction();
              } else {
                if (this.$route.name == 'dispatchMap' || this.$route.name == 'followUpMap' || this.$route.name == 'eocMap') {
                  window.close();
                } else {
                  this.$router.push({ name: 'login' });
                }
              }
            });
          } else if (this.$store.state.phoneOnlineLocationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllPhoneOnlineLocationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.phoneOnlineLocationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
